import styles from './EmployeeBio.module.scss';

import { convertMarkdown, useIsMobile } from '@/ui/utils';
import { ResponsiveImage, SocialLinks } from '@/ui/base';
import { EmployeeBioProps } from '@/types';

const EmployeeBio = ({ cardInfo }: EmployeeBioProps) => {
  const {
    employeeName,
    employeeJobTitle,
    employeeBio,
    employeeLinkedIn,
    employeeTwitter,
    employeeImage,
  } = cardInfo;

  const isMobile = useIsMobile();

  return (
    <div className={styles.employeeBio}>
      <div className={styles.employeeBio__inner}>
        <div className={styles.employeeBio__left}>
          <div className={styles.employeeBio__image}>
            {employeeImage && (
              <ResponsiveImage
                media={employeeImage}
                sizes={{ sm: 400, smd: 768, md: 948 }}
                className={styles.employeeBio__imageFile}
              />
            )}
          </div>
        </div>

        <div className={styles.employeeBio__right}>
          <div className={styles.employeeBio__content}>
            <h4 className={styles.employeeBio__name}>{employeeName}</h4>
            <div className={styles.employeeBio__jobTitle}>
              {employeeJobTitle}
            </div>
            {!isMobile && (
              <div className={styles.employeeBio__bio}>
                {!!employeeBio && convertMarkdown(employeeBio)}
              </div>
            )}
            <div className={styles.employeeBio__contact}>
              <SocialLinks
                {...{
                  twitter: employeeTwitter,
                  linkedIn: employeeLinkedIn,
                  darkIcon: true,
                  smaller: true,
                }}
              />
            </div>
          </div>
        </div>
        {isMobile && (
          <div className={styles.employeeBio__bottom}>
            <div className={styles.employeeBio__bio}>
              {!!employeeBio && convertMarkdown(employeeBio)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployeeBio;
